import { Paper, Theme, styled } from '@mui/material';

export const StyledGoalItemWrap = styled('div')(() => ({
	position: 'relative',
	paddingTop: '20px',
}));

export const StyledGoalItemInnerWrap = styled(Paper, {
	shouldForwardProp: (prop) => prop !== 'type',
})(({ theme, type }: { theme: Theme; type: 'error' | 'warning' | 'info' | 'success' }) => ({
	borderRadius: '20px',
	borderTop: `4px solid ${theme.palette[type].contrastText}`,
	gap: '8px',
	display: 'flex',
	flexDirection: 'column',
	height: '100%',
	textAlign: 'center',
	padding: '16px',
	margin: 0,
}));

export const StyledGoalItemProgressWrap = styled('div')({
	position: 'absolute',
	top: '0px',
	left: '50%',
	transform: 'translateX(-50%)',
});

export const StyledGoalItemItemsList = styled('ul')({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
	margin: 0,
	padding: 0,
	flex: 1,
	listStyleType: 'none',
});

export const StyledGoalItemListItem = styled('li', {
	shouldForwardProp: (prop) => prop !== 'type',
})(({ theme, type }: { theme: Theme; type: 'error' | 'warning' | 'info' | 'success' }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',

	'& label': {
		margin: 0,
		display: 'flex',
		alignItems: 'flex-start',
		gap: '8px',
		fontSize: '14px',
		lineHeight: '20px',
		letterSpacing: '0.17px',

		'&:hover .MuiTypography-root': {
			color: theme.palette[type].contrastText,
		},
	},
	'& .MuiCheckbox-root': {
		height: 'auto',
		padding: 0,
		color: `${theme.palette[type].contrastText} !important`,

		'&.Mui-disabled': {
			color: `${theme.palette[type].contrastText} !important`,
		},
	},
	'& .MuiTypography-root': {
		transition: 'all .3s',
	},
}));
